module.exports = __webpack_public_path__ + "img/Group 1196.4c21b9c1.svg";